/* Creed Fashion: kdaj se pokaže okno za prijavo na e-novice.
   Samo krmiljenje: okno in obrazec izriše sections/creed-signup-form.liquid
   (obrazec mora biti Liquid in viden, sicer Shopifyjeva zaščita proti robotom
   ne deluje). Tu skrbimo za čas prikaza, zapiranje, zavihek in privolitev.
   6. 10. 2026: ?prijava=1 ali #prijava odpre okno takoj (povezave iz mailov);
   po zaprtju ostane v kotu zavihek "10 % za prijavo"; na telefonu prikaz po 10 s. */
(function () {
  'use strict';
  if (window.Shopify && Shopify.designMode) return;

  var KEY_DONE = 'creedSignupDone';
  var KEY_SEEN = 'creedSignupSeen';
  var AGAIN_AFTER = 30 * 24 * 60 * 60 * 1000;
  var TOUCH = ('ontouchstart' in window) || (window.matchMedia && matchMedia('(hover: none)').matches);
  var DELAY = TOUCH ? 10000 : 15000;

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var box = document.getElementById('creed-su');
    var tab = document.getElementById('creed-su-tab');
    if (!box) return;

    var path = window.location.pathname;
    var blocked = /\/(cart|checkouts?|account|challenge|password)(\/|$)/.test(path);
    var forced = /[?&]prijava=1(&|$)/.test(window.location.search) || /#prijava/.test(window.location.hash);

    function showTab() { if (tab && !ls(KEY_DONE) && !blocked) tab.hidden = false; }
    function hideTab() { if (tab) tab.hidden = true; }

    function hide() {
      box.classList.remove('is-open');
      setTimeout(function () { box.hidden = true; showTab(); }, 300);
    }

    var closeBtn = box.querySelector('.creed-su__x');
    if (closeBtn) closeBtn.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) hide(); });

    /* po uspešni oddaji: zahvala je že izrisana, samo počistimo naslov strani */
    if (box.getAttribute('data-posted') === 'true') {
      lsSet(KEY_DONE, '1');
      hideTab();
      try {
        var clean = window.location.pathname + window.location.search
          .replace(/[?&]customer_posted=true/, '')
          .replace(/^&/, '?');
        history.replaceState({}, '', clean + window.location.hash.replace(/#creed-signup-form/, ''));
      } catch (e) {}
      setTimeout(function () {
        box.classList.remove('is-open');
        setTimeout(function () { box.hidden = true; }, 300);
      }, 6000);
      return;
    }

    /* privolitev v slovenščini namesto privzetega brskalnikovega besedila */
    var consent = box.querySelector('#creed-su-consent');
    if (consent) {
      var msg = consent.getAttribute('data-msg') || '';
      var setMsg = function () { consent.setCustomValidity(consent.checked ? '' : msg); };
      setMsg();
      consent.addEventListener('change', setMsg);
    }

    /* napaka pri oddaji: okno je že odprto (Liquid), ne skrivamo ga */
    if (box.classList.contains('is-open')) { hideTab(); return; }

    if (ls(KEY_DONE)) return;

    function show() {
      if (document.querySelector('.creed-oto-overlay')) return; /* ne motimo OTO ponudbe */
      lsSet(KEY_SEEN, String(Date.now()));
      hideTab();
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      cleanup();
    }
    window.creedSignupShow = show;

    if (tab) tab.addEventListener('click', show);

    if (forced) { setTimeout(show, 600); return; }
    if (blocked) return;

    var seen = parseInt(ls(KEY_SEEN) || '0', 10);
    if (seen && Date.now() - seen < AGAIN_AFTER) { showTab(); return; }

    var timer = setTimeout(show, DELAY);

    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.5) { clearTimeout(timer); show(); }
    }
    function onLeave(e) {
      if (e.clientY <= 0) { clearTimeout(timer); show(); }
    }
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseleave', onLeave);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    if (!TOUCH) document.addEventListener('mouseleave', onLeave);
  });
})();
